<template>
  <div
    class="old-customer-bonus-container"
    :style="`background-image:url(${data.icon});`"
  >
    <nd-button
      class="withdraw"
      @click="handleButtonClick('TMD_WITHDRAW')"
      :class="`caseid-${caseid}`"
    >去领取</nd-button>
    <p class="detail-btn" @click="$router.push('/actvie/oldCustomerBonus')"  :class="`caseid-${caseid}`" data-sensors-click>活动详情 ></p>
  </div>
</template>

<script>
export default {
  data () {
    return {
      visible: true     
    }
  },
  props: {
    caseid: {
      type: [String, Number],
      default: ''
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },

  methods: {    
    open () {
      this.visible = true
    },
    close () {
      this.visible = false
      this.$emit('close')
    },
    show () {},
    handleButtonClick (skipType) {
      const { couponSerialNo } = this.data
      const query = {
        skipType,
        cacheCouponSerialNo: 'Y'
      }
      if (couponSerialNo) {
        query.couponSerialNo = couponSerialNo
      }
      this.$router.push({
        path: '/middle/coupon',
        query
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../../assets/less/mixin.less";

.old-customer-bonus-container {
  width: 620px;
  height: 750px;
  background-size: 100% 100%;
  padding-top: 540px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .withdraw {
    width: 440px;
    height: 80px;
    background: linear-gradient(90deg, #ff3333 0%, #ff5f34 100%);
  }
  .detail-btn {
    font-family: PingFangSC, PingFang SC;
    font-size: 28px;
    margin-top: 17px;
    padding: 10px 0;
    color: #fff;
  }
}
</style>